import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LoaderButton } from '../../../../../shared/components/loader-button/loader-button.component';
import { ModalService } from '../../../../../shared/services/modal/modal.service';
import { ContentService } from '../../../../../shared/services/app/content/content.service';
import { Toast } from '../../../../../shared/components/toast/toast.service';

@Component({
  selector: 'tog-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent implements OnInit {
  modalSubscription: Subscription;
  @Input() title: string;
  @Input() body: string;
  @Input() type: string;
  @Input() toDelete: any;
  @Input() previewSpinner: any;
  @Output('confirmation') confirmation = new EventEmitter();
  @Output('firstPage') firstPage = new EventEmitter();
  @Output('promotion') promotion = new EventEmitter();
  @Output('push') push = new EventEmitter();
  @ViewChild('confirmDeleteButton') confirmDeleteButton: LoaderButton;
  constructor(public _modalService: ModalService,
              public contentService: ContentService,
              public _toast: Toast) { }

  @Input() set itemDeleted(isDeleted) {
    if (isDeleted) this.confirmDeleteButton.setConfirmed();
  }

  ngOnInit() {
  }

  confirm() {
    if (this.previewSpinner) this.previewSpinner.show();
    switch (this.type) {
      case 'calendar': this.confirmDeleteEvent(); break;
      case 'nav-item': this.confirmDeleteNavItem(); break;
      case 'pod': this.confirmDeletePod(); break;
      case 'page': this.confirmDeletePage(); break;
      case 'promo': this.confirmDeletePromotion(); break;
      case 'push': this.confirmDeletePush(); break;
    }

    this.itemDeleted = true;
    setTimeout(() => {
      this.itemDeleted = false;
    }, 5);

    if (this.previewSpinner) this.previewSpinner.hide();
  }

  confirmDeleteEvent() {
    this.contentService.events.delete(this.toDelete)
    .then(() => {
      this._toast.success('Event deleted!');
    })
    .catch(() => {
      this._toast.error('Error deleting Event.');
    });
  }

  confirmDeleteNavItem() {
    this.contentService.navItems.delete(this.toDelete)
    .then(() => {
      this._toast.success('Navigation menu item deleted!');
    })
    .catch(() => {
      this._toast.error('Error deleting navigation menu item.');
    });
  }

  confirmDeletePage() {
    this.contentService.deletePage(this.toDelete)
    .then(() => {
      setTimeout(() => {
        this.firstPage.emit('emit');
      }, 0);
      this._toast.success(this.toDelete.type + ' deleted!');
    })
    .catch(() => {
      this._toast.error('Error deleting ' + this.toDelete.type + '.');
    });
  }

  confirmDeletePod() {
    this.contentService.pods.delete(this.toDelete)
    .then(() => {
      this._toast.success('Home screen pod deleted!');
    })
    .catch(() => {
      this._toast.error('Error deleting home screen pod.');
    });
  }

  confirmDeletePromotion() {
    this.contentService.promotions.delete(this.toDelete)
    .then(() => {
      this.promotion.emit('');
      this._toast.success('Promotion deleted!');
    })
    .catch(() => {
      this._toast.error('Error deleting Promotion.');
    });
  }

  confirmDeletePush() {
    this.contentService.push.delete(this.toDelete)
    .then(() => {
      return this.contentService.push.getAllNotifications();
    })
    .then((notifications) => {
      this._toast.success('Push notification deleted!');
      this.push.emit(notifications);
    });

  }

}



// WEBPACK FOOTER //
// /app/src/app/screens/togglit/application/features/delete-modal/delete-modal.component.ts